import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAuthenticated, logout } from "../common/api/auth";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { AuthContext } from "../context/AuthContext";
import { ReportsContext } from "../context/ReportsContext";
import ModalSelectClient from "./user-management/ModalSelectClient";

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
  const [codClients, setCodClients] = useState([]);
  const [reportClients, setReportClients] = useState([]);
  const [reportsStatus, setReportsStatus] = useState("idle");
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [selectedReportClient, setSelectedReportClient] = useState("");

  useEffect(() => {
    const pendingUser = sessionStorage.getItem("pending_user");

    if (pendingUser) {
      if (location.pathname !== "/set-password") {
        navigate("/set-password", {
          replace: true,
          state: { username: pendingUser },
        });
      }
      return;
    }

    if (!isAuthenticated()) {
      navigate("/login", { replace: true });
    }
  }, [location.pathname, navigate]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setCodClients([]);
      setReportsStatus("idle");
      return;
    }
    if (!isLoggedIn) {
      setCodClients([]);
      setReportsStatus("idle");
      return;
    }

    let isMounted = true;
    const controller = new AbortController();

    const fetchCodClients = async () => {
      setReportsStatus("loading");
      try {
        const token = localStorage.getItem("token");
        const res = await fetch("/reports-api/myreports/codclients", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });

        if (!res.ok) {
          if (res.status === 401) {
            await logout();
            if (isMounted) {
              setIsLoggedIn(false);
              navigate("/login", { replace: true });
            }
            return;
          }

          if (isMounted) {
            setCodClients([]);
            setReportsStatus("error");
          }
          return;
        }

        console.log("codclients status:", res.status);
        const data = await res.json();
        console.log("codclients payload:", data);
        const cods = Array.isArray(data?.codClients) ? data.codClients : [];
        const namedClients = Array.isArray(data?.clients) ? data.clients : [];

        if (isMounted) {
          setCodClients(cods);
          setReportClients(namedClients);
          setReportsStatus("success");
        }

      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }
        if (isMounted) {
          setCodClients([]);
          setReportsStatus("error");
        }
      }
    };

    fetchCodClients();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [isLoggedIn, navigate, setIsLoggedIn]);
  const reportOptions = useMemo(() => {
    if (Array.isArray(reportClients) && reportClients.length > 0) {
      return reportClients;
    }

    // fallback por seguridad
    return codClients.map(cod => ({
      value: cod,
      label: `Reporte ${cod}`,
    }));
  }, [reportClients, codClients]);


  const handleReportsClick = () => {
    if (codClients.length === 1) {
      navigate(`/myreports/${codClients[0]}`);
      return;
    }

    if (codClients.length > 1) {
      setSelectedReportClient(reportOptions[0]?.value ?? "");
      setShowReportsModal(true);
      return;
    }

    navigate("/myreports");
  };

  const handleSelectReportClient = () => {
    if (!selectedReportClient) {
      return;
    }
    setShowReportsModal(false);
    navigate(`/myreports/${selectedReportClient}`);
  };

  const handleCloseReportsModal = () => {
    setShowReportsModal(false);
    setSelectedReportClient("");
  };

  return (
    <>
      <Topbar />
      <ReportsContext.Provider value={{ codClients, reportClients, reportsStatus }}>
        <div className="cuerpo_home">
          <Sidebar
            codClients={codClients}
            reportsStatus={reportsStatus}
            onReportsClick={handleReportsClick}
          />
          <main className="contenido">{children}</main>
        </div>
        {showReportsModal && (
          <ModalSelectClient
            clients={reportOptions}
            selectedClient={selectedReportClient}
            setSelectedClient={setSelectedReportClient}
            onSelect={handleSelectReportClient}
            onClose={handleCloseReportsModal}
          />
        )}
      </ReportsContext.Provider>
    </>
  );

}

export default Layout;
